import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { AuditTrailModule } from '@iot-platform/audit-trail';
import { AuditTrailService } from './audit-trail.service';
export { TrackingSettingsProviderService } from './tracking-settings-provider.service';

export const provideBamAuditTrailSettings = (): EnvironmentProviders =>
  importProvidersFrom(
    AuditTrailModule.forRoot({
      auditTrailService: AuditTrailService,
      exportLogDetails: false
    })
  );
